var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-12" }, [
          _c(
            "div",
            {
              staticClass: "bar",
              staticStyle: { "margin-left": "5px", "margin-right": "5px" },
              attrs: { id: "bar" }
            },
            _vm._l(_vm.parts, function(part) {
              return _c(
                "div",
                {
                  key: part.title,
                  staticClass: "barPart",
                  class: part.class,
                  style: part.style,
                  attrs: { title: part.title }
                },
                [_vm._v(_vm._s(part.text))]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24c5ffdb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c5ffdb","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/TaxBar.vue
// module id = 25
// module chunks = 0